"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = require("prop-types");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Sentiment(_ref, svgRef) {
  var sentiment = _ref.sentiment,
      active = _ref.active,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["sentiment", "active"]);
  var mouth;
  var fillColor;

  switch (sentiment) {
    case -1:
      mouth = (0, _jsxRuntime.jsx)("path", {
        d: "M15 35.62s2.6-4.37 10-4.37 10 4.37 10 4.37",
        fill: "none"
      });
      fillColor = 'var(--color-primary-negative)';
      break;

    case 1:
      mouth = (0, _jsxRuntime.jsx)("path", {
        d: "M15 33.62s2.6 5.63 10 5.63 10-5.63 10-5.63",
        fill: "none"
      });
      fillColor = 'var(--color-primary-positive)';
      break;

    default:
      mouth = (0, _jsxRuntime.jsx)("path", {
        fill: "none",
        d: "M15 34.62h20"
      });
      fillColor = 'var(--color-monochrome-mediumDark)';
  }

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "25",
    height: "25",
    stroke: "var(--color-monochrome-black)",
    fill: "var(--color-monochrome-black)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("circle", {
      cx: "25",
      cy: "25",
      r: "24",
      fill: active ? fillColor : 'none',
      stroke: active ? fillColor : undefined,
      strokeWidth: "2"
    }), (0, _jsxRuntime.jsx)("circle", {
      cx: "15",
      cy: "19",
      r: "4"
    }), (0, _jsxRuntime.jsx)("circle", {
      cx: "35",
      cy: "19",
      r: "4"
    }), mouth]
  }));
}

Sentiment.propTypes = {
  sentiment: (0, _propTypes.oneOf)([-1, 0, 1]),
  active: _propTypes.bool
};
Sentiment.defaultProps = {
  sentiment: undefined,
  active: false
};
var ForwardRef = /*#__PURE__*/React.forwardRef(Sentiment);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Sentiment.js.map